import { API_ENDPOINTS } from '@utils/endpoints';
import { BaseService } from '../baseService';
import { ConfigResponse } from '@models/Config';

export class configService {
  /**
   * @function getConfig
   * @returns ConfigResponse
   */
  static getConfig = async (): Promise<ConfigResponse> => {
    const response = await BaseService.get(API_ENDPOINTS.CONFIG);
    return response as ConfigResponse;
  };
}
